var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-24 bg-light-green text-white rounded-lg grid content-center px-4 mb-5"},[_c('span',{staticClass:"text-xl font-semibold"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"text-base"},[_vm._v(_vm._s(_vm.subtitle || ""))])])
}
var staticRenderFns = []

export { render, staticRenderFns }